import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/global.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import api from './api'
import '@/assets/fontsto/iconfont.css'
import '@/assets/fonthome/iconfont.css'
import '@/assets/fontYsu/iconfont.css'
import * as echarts from 'echarts'
import Print from 'vue-print-nb'
import VueI18n from 'vue-i18n'
import enLocale from './i18n/en'
import zhLocale from './i18n/zh'
// // 使用datav
import dataV from '@jiaminghi/data-view'
import AppBreadcrumb from '@/components/AppBreadcrumb'

// this.famlis.token = this.$store.state.print.goodsForeNo.token

// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) {
//     console.log(sessionStorage, 'sessionStorage.getItem')
//     next()
//     if (sessionStorage.getItem('token')) {
//     } else {
//       next({
//         path: '/'
//       })
//     }
//   } else {
//     next()
//   }
// })
Vue.use(VueI18n)

// 创建i18n实例
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh', // 设置语言
  messages: {
    zh: zhLocale,
    en: enLocale
  }
})
Vue.use(dataV)

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Print)
Vue.prototype.$api = api
Vue.component('AppBreadcrumb', AppBreadcrumb)

// iOS 设备全局交互修复：
// 1) el-select 首次触摸只高亮不选中 -> touchend 主动触发 click
// 2) 标记 iOS class，配合全局 CSS 防止 input/select 点击触发页面放大
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const ua = window.navigator.userAgent || ''
  const isIOS = /iP(hone|od|ad)/i.test(ua) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)

  if (isIOS) {
    document.body.classList.add('ios-device')
    document.body.addEventListener('touchend', (e) => {
      const target = e && e.target
      if (!target || !target.closest) return
      const item = target.closest('.el-select-dropdown__item')
      if (!item) return
      if (item.classList && item.classList.contains('is-disabled')) return
      e.preventDefault()
      e.stopPropagation()
      item.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))
    }, { passive: false })
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
